import React, { ReactNode } from 'react';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import {
  maxTablet, maxWidth1170,
  primaryColor, primaryFont, primaryHeadingColor, wMBold, wMedium,
} from 'Utils/utilsStyle';
import { RightOutlined } from '@ant-design/icons';
import { useDispatch } from 'react-redux';
import { actions as certificationActions } from 'Slice/CertificationSlice';
import { actions as flurryActions } from 'Slice/HelperSlice';
import { valueToObject } from 'Utils/UtilityFunctions';
import { COMPANY_NEWS_ROUTE } from 'Utils/Constants';

type Props = {
  heading?: string,
  count?: number,
  children: ReactNode,
  id: number,
} & typeof defaultProps;

const defaultProps = {
  heading: '',
  count: 0,
};

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  align-items: flex-start;
  margin-bottom: 10px;
  .pulse-area {
    width: 100%;
    .heatmap-row { 
      width: 100%;
    }
  }
  .heading {
   font-size: 14px;
   font-weight: ${wMedium};
   line-height: 16px;
   letter-spacing: -0.25px;
   color: ${primaryHeadingColor};
   font-family: ${primaryFont};
   margin-bottom: 6px;
   transition: 0.5 ease all;
    @media all and (max-width: ${maxWidth1170}) and (min-width: ${maxTablet}) {
    font-size: 13px;
  }
   &:hover {
      font-weight: ${wMBold};
      transition: 0.5 ease all;
      color: ${primaryColor};
    .ant-icons-right {
      margin: 2px 0px 0px 12px;
      svg {
        color: ${primaryColor}
      }
    }
   }
  }
  .ant-icons-right{
    margin: 2px 0px 0px 8px;
    font-size: 13px;
    svg {
      color: #424B50;
    }
  }
`;

const HeatMapItem = function HeatMapItem(props: Props) {
  const {
    heading, children, count, id,
  } = props;
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const host = window.location.href;

  const handleClick = () => {
    dispatch(certificationActions.setPulseCompanyClicked(true));
    navigate(`${COMPANY_NEWS_ROUTE}${id}`);
    dispatch(flurryActions.callFlurryEvent(
      valueToObject('feedpage_pulse_company_click', 0, {
        host,
      }),
    ));
  };
  return (
    <Wrapper className="heatmap-item">
      <span
        className="heading text-truncate c-pointer"
        onClick={handleClick}
        onKeyPress={handleClick}
        tabIndex={0}
        role="button"
        aria-label="Forward"
      >
        {`${heading} (${count})`}
        <span className="ant-icons-right"><RightOutlined /></span>
      </span>
      <div className="pulse-area">{children}</div>
    </Wrapper>
  );
};

HeatMapItem.defaultProps = defaultProps;
export default HeatMapItem;
